var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#323130;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,16c-2,0-4.1-0.8-5.7-2.3c-3.1-3.1-3.1-8.2,0-11.3c3.1-3.1,8.2-3.1,11.3,0c3.1,3.1,3.1,8.2,0,11.3 C12.1,15.2,10,16,8,16z M8,0.9C6.2,0.9,4.4,1.6,3,3c-2.8,2.8-2.8,7.3,0,10c2.8,2.8,7.3,2.8,10,0c2.8-2.8,2.8-7.3,0-10 C11.6,1.6,9.8,0.9,8,0.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,10.6c-0.1,0-0.2,0-0.3-0.1L5.5,6.2C5.4,6,5.4,5.7,5.5,5.5c0.2-0.2,0.5-0.2,0.6,0l4.3,4.3 c0.2,0.2,0.2,0.5,0,0.6C10.4,10.5,10.3,10.6,10.1,10.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.9,10.6c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.6l4.3-4.3c0.2-0.2,0.5-0.2,0.6,0c0.2,0.2,0.2,0.5,0,0.6 l-4.3,4.3C6.1,10.5,6,10.6,5.9,10.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSearch);
export default __webpack_public_path__ + "static/media/close-search.4e2fbbfd920bc8e2ac474631a1a8159c.svg";
export { ForwardRef as ReactComponent };